// Lightweight, purely client-side "companion" simulation.
// Nothing here ever touches the network or database — it's just numbers
// for a fun side-by-side comparison the kid sees on screen. Never compared
// against or written into any real score table.

export const COMPANION_OPTIONS = [
  { label: "Mom", emoji: "👩" },
  { label: "Dad", emoji: "👨" },
  { label: "Sister", emoji: "👧" },
  { label: "Brother", emoji: "👦" },
  { label: "Grandma", emoji: "👵" },
  { label: "Grandpa", emoji: "👴" },
  { label: "Teacher", emoji: "🍎" },
  { label: "Big Buddy", emoji: "🧑" },
];

export function emojiForCompanion(name) {
  const match = COMPANION_OPTIONS.find((opt) => opt.label === name);
  return match ? match.emoji : "🧑"; // generic fallback for custom-typed names
}

// Companion is intentionally generous with time (not lightning fast) so the
// kid has a real, winnable chance to beat her on speed — accuracy stays high
// because "Mom getting stuck on the elephant match" wouldn't feel authentic.
export function simulateCompanionLevel(totalQuestions = 5) {
  const correctCount =
    Math.random() < 0.85 ? totalQuestions : Math.max(totalQuestions - 1, 1); // occasionally "misses one" — feels human, still generous

  const perQuestionSec = 7 + Math.random() * 5; // 7–12s per question: unhurried, beatable
  const timeTakenSec = Math.round(totalQuestions * perQuestionSec);

  return { correctCount, totalQuestions, timeTakenSec, hintsUsed: 0 };
}

// Simulates the companion playing through all 5 levels upfront, all at once.
export function simulateCompanionFullGame(levelQuestionCounts = [5, 5, 5, 5, 5]) {
  return levelQuestionCounts.map((count) => simulateCompanionLevel(count));
}

// Cosmetic-only score estimate — does NOT need to match the real backend
// formula, since this number is never saved or compared against real data.
export function estimateScore({ correctCount, totalQuestions, timeTakenSec }) {
  const accuracyPts = Math.round((correctCount / totalQuestions) * 700);
  const speedBonus = Math.max(0, 300 - timeTakenSec * 2);
  return accuracyPts + speedBonus;
}

export function compareEmoji(kidTimeSec, companionTimeSec) {
  if (kidTimeSec == null || companionTimeSec == null) return null;
  const diff = companionTimeSec - kidTimeSec; // positive = kid was faster
  if (diff > 5) return { emoji: "🚀", label: "Way faster!" };
  if (diff > 0) return { emoji: "⭐", label: "Faster!" };
  if (diff > -5) return { emoji: "🐢", label: "So close!" };
  return { emoji: "💪", label: "Keep going!" };
}